import React from "react";
import DOMPurify from 'dompurify';

export class CalendarFilter extends React.Component<any , any> {
    constructor(props:any) {
        super(props);
    }

    render() {
        // var product_filter = this.props;

        return (
            <div className="product--filter" style={{marginTop:"10px"}}>
                <div className="product--input-wrapper">
                <input
                    type="search"
                    name="filter_search"
                    defaultValue=""
                    placeholder="Search"
                    onChange={event => {
                        const sanitizedValue = DOMPurify.sanitize(event.target.value);
                        this.props.onSearch(sanitizedValue);
                    }}
                />
                </div>
                <div className="product--input-wrapper"><div className="spacer"></div></div>
            </div>
        )
    }
}
